import { createContext, useContext } from 'react';

// Whether the backend is currently inviting the user to give feedback (#212).
//
// Seeded from the profile on load (UserProfileDto.feedbackInvitation) and refreshed by the
// answer to each message (ChatUpdateFullResponse.feedbackInvitation), so the ask arrives with
// the experience it asks about and still survives a reload. The browser never counts messages
// itself: it only relays what the server decided.
//
// `dismiss` records the user's refusal server-side; a dismissed banner does not come back, here
// or on another device.
//
// `markGiven` retires the ask once the user has answered it. The server already knows — it will
// not invite someone who has submitted — but nothing refetches the profile mid-session, so the
// screen would otherwise keep asking for what it has just been given.
export const FeedbackInvitationContext = createContext({
  invited: false,
  dismiss: () => {},
  markGiven: () => {},
});

export function useFeedbackInvitation() {
  return useContext(FeedbackInvitationContext);
}
